export default __webpack_public_path__ + "static/media/bg-kingfreight.bdd3c218.jpg";